module.exports = "<button [ngClass]=\"config.style\" type=\"submit\" [disabled]=\"!group.valid\">\n  {{ config.label }}\n</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/dynamic-form/components/form-button/form-button.component.html
// module id = ./src/app/modules/shared/dynamic-form/components/form-button/form-button.component.html
// module chunks = main